// extracted by mini-css-extract-plugin
module.exports = {"datum":"styles_datum__1q2Fm","headerContent":"styles_headerContent__198o1","contentContainer":"styles_contentContainer__1TaLT"};